const build = require('./build-version')
let prodConfig = {
  NODE_ENV: '"production"',
  BUILD: build.buildVersion
}
export default prodConfig
